import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import {
  type AuthErrorField,
  extractApiErrorCode,
  mapApiError
} from '@/utils/api/mapApiError'

export type TranslatedAuthError =
  | { kind: 'field'; field: AuthErrorField; message: string }
  | { kind: 'view'; action: 'showEmailAlreadyInUse' }
  | { kind: 'toast'; message: string }

interface TranslateOptions {
  otpContext?: boolean
}

export const useApiErrorTranslator = () => {
  const t = useTranslations('errors.auth')

  return useCallback(
    (error: unknown, options: TranslateOptions = {}): TranslatedAuthError => {
      const result = mapApiError(error, options)
      const suffix =
        process.env.NODE_ENV !== 'production'
          ? ` [${extractApiErrorCode(error) ?? 'UNKNOWN'}]`
          : ''

      if (result.kind === 'view') {
        return { kind: 'view', action: result.action }
      }

      const message = t(result.key) + suffix

      if (result.kind === 'field') {
        return { kind: 'field', field: result.field, message }
      }

      return { kind: 'toast', message }
    },
    [t]
  )
}
